// extracted by mini-css-extract-plugin
module.exports = {"filters":"TreatmentFilter_filters___nXz4","button":"TreatmentFilter_button__VDdSn","filterCount":"TreatmentFilter_filterCount__gOh9l"};